<template>
	<div class="fff">
		<div v-for="(item, index) in NewList" :key="index">
			<el-row>
				<el-col :span="24">
					<h3>{{ item.title }}</h3>
				</el-col>
				<el-col :span="8">
					<span>{{$t("menu.releaseDate") }}<span>{{ item.releaseDate }}</span></span>
				</el-col>
				<el-col :span="8">
					<span>{{$t("menu.source") }}<span>{{item.source}}</span></span>
				</el-col>
				<el-col :span="8">
					<span>{{$t("menu.publisher") }}<span>{{item.publisher}}</span></span>
				</el-col>
				<el-col :span="24">
					<div v-html="item.details"></div>
				</el-col>
			</el-row>
		</div>

		<el-row>
			<div v-for="(iteme, indexe) in fristList" :key="indexe">
				<el-col :span="24">
					<p @click="btnfrist(iteme)"> {{$t("menu.previousposts") }}
						<span class="p"> {{iteme.title}}</span>
					</p>
				</el-col>
			</div>
			<div v-for="(items, indexs) in lastList" :key="indexs">
				<el-col :span="24">
					<p @click="BtnLast(items)">{{$t("menu.nextChapter") }} <span class="p"> {{items.title}}</span></p>
				</el-col>
			</div>
		</el-row>

	</div>
</template>

<style scoped lang="less">
	h3 {
		font-size: 20px;
	}

	.fff {
		background: #fff;
		margin-top: 25px;
	}

	span {
		font-size: 14px;
		color: #cccccc;
	}

	.p {
		font-size: 16px;
		display: inline-block;
		font-weight: normal;
		color: #333333;
	}
	
	/deep/ .pic{
		white-space: normal;
	}

	::v-deep p {
		line-height: 1.8;
	}
</style>

<script>
	export default {
		name: "Particulars",
		inject: ['reload'],
		data() {
			return {
				title: "",
				NewList: [],
				lastList: [],
				fristList: []
			};
		},
		created: function() {
			if (this.$i18n.locale == "TC") {
				this.title = "TC";
			} else if (this.$i18n.locale == "EN") {
				this.title = "EN";
			} else if (this.$i18n.locale == "SC") {
				this.title = "SC";
			}
			this.getSelect();
		},
		methods: {
			async getSelect() {
				let ti = this.$route.query.ti;
				let category = this.$route.query.category;
				const {
					data: resER
				} = await this.$http.get(
					"/News/GetNewsInfo", {
						params: {
							page: 1,
							size: 1,
							pid: ti,
							category: category,
							languageType: this.title,
						},
					}
					//
				);

				if (resER.code !== 200) return console.log("数据请求失败! ");

				this.NewList = resER.data.current;
				// 下一个
				this.lastList = resER.data.next;
				// 第一个
				this.fristList = resER.data.upper;

				console.log(this.NewList)
			},
			//前面点击按钮
			btnfrist(val) {
				if (val.category == "Company") {
					this.$router.push({
						path: "/CompanyDnamic/Particulars",
						query: {
							ti: val.pid,
							category: val.category
						}
					});
				} else {
					this.$router.push({
						path: "/IndustryInformation/Particulars",
						query: {
							ti: val.pid,
							category: val.category
						}
					});
				}

				this.refresh();
			},
			// 点击后面按钮
			BtnLast: function(val) {
				if (val.category == "Company") {
					this.$router.push({
						path: "/CompanyDnamic/Particulars",
						query: {
							ti: val.pid,
							category: val.category
						}
					});
				} else {
					this.$router.push({
						path: "/IndustryInformation/Particulars",
						query: {
							ti: val.pid,
							category: val.category
						}
					});
				}
				this.refresh();
			},

			refresh: function() {
				//页面刷新
				this.reload()
			},


		},
	};
</script>
